import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      toast.error('Sessão inválida');
      navigate('/login');
      return;
    }

    const exchangeSession = async () => {
      try {
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/session`,
          {},
          {
            headers: { 'X-Session-ID': sessionId },
            withCredentials: true
          }
        );

        const { user, session_token } = response.data;

        // Session timeout: 180 seconds (3 minutes)
        document.cookie = `session_token=${session_token}; path=/; max-age=180; secure; samesite=none`;

        toast.success('Autenticado com sucesso!');
        
        const dashboardPath = user.role === 'operador' ? '/operador' : user.role === 'dpo' ? '/dpo' : '/dashboard';
        navigate(dashboardPath, { state: { user }, replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Erro na autenticação');
        navigate('/login');
      }
    };

    exchangeSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#10B981] mx-auto mb-4"></div>
        <p className="text-slate-600">A autenticar...</p>
      </div>
    </div>
  );
};

export default AuthCallback;